import React from "react";
import {
  MainNav,
  MainNavButton,
  MainNavLink,
  useLayoutScreenContext,
} from "@compono/ui";
import * as intercom from "@shortlyster/intercom-kit";
import { ShowIf } from "~/components/auth/ShowIf";
import { useAuthentication } from "~/hooks/useAuthentication";

import { SignInOutlineIcon } from "../icons/SignInOutlineIcon";
import { MembershipOutlineIcon } from "../icons/MembershipOutlineIcon";
import { NavLink } from "../NavLink";

import { LockedSolidIcon } from "@compono/ui-icons";

import { AdminNav } from "./AdminNav";
import { EngageNav } from "./EngageNav";
import { DevelopNav } from "./DevelopNav";
import { HireNav } from "./HireNav";
import { PeopleNav } from "./PeopleNav";
import { ReportsNav } from "./ReportsNav";
import { HeyComponoNavPanel } from "~/components/HeyComponoNavPanel";

export const SideNav = () => {
  const { logout } = useAuthentication();
  const { sidebar } = useLayoutScreenContext({ optional: true });
  const { isCollapsed } = sidebar.collapseState;

  const signOut = () => {
    if (
      document.body.getAttribute("data-modified") &&
      !window.confirm(
        "You have unsaved changes. Changes will be lost if you leave this page.",
      )
    )
      return;

    window.sessionStorage.clear();
    intercom.shutdown();

    logout({ post_logout_redirect_uri: window.location.origin });
  };

  return (
    <MainNav navLinkComponent={NavLink}>
      <ShowIf
        allowedTo="product.hire"
        ifNotRender={
          <MainNavLink
            target="_blank"
            href="https://www.compono.com/products/hire"
            icon={LockedSolidIcon}
            label="Hire"
          />
        }
      >
        <HireNav />
      </ShowIf>
      <ShowIf
        allowedTo="product.engage"
        ifNotRender={
          <MainNavLink
            target="_blank"
            href="https://www.compono.com/products/engage"
            icon={LockedSolidIcon}
            label="Engage"
          />
        }
      >
        <EngageNav />
      </ShowIf>
      <ShowIf
        allowedTo="product.develop"
        ifNotRender={
          <MainNavLink
            target="_blank"
            href="https://www.compono.com/products/develop"
            icon={LockedSolidIcon}
            label="Develop"
          />
        }
      >
        <DevelopNav />
      </ShowIf>
      <PeopleNav />
      <ShowIf allowedTo="hireReports.view">
        <ReportsNav />
      </ShowIf>
      <AdminNav />
      <MainNavLink
        icon={MembershipOutlineIcon}
        href={`/profile`}
        label="My profile"
      />
      <MainNavButton
        icon={SignInOutlineIcon}
        onClick={signOut}
        data-testid="logout-link"
        label="Log out"
      />
      {!isCollapsed && <HeyComponoNavPanel />}
    </MainNav>
  );
};
